var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icons",
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.274,
    height: 12.274,
    viewBox: "0 0 12.274 12.274",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Black",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Instagram",
    d: "M506.137,160c-1.667,0-1.876.007-2.53.037a4.5,4.5,0,0,0-1.49.285,3.138,3.138,0,0,0-1.795,1.795,4.5,4.5,0,0,0-.285,1.49c-.03.655-.037.864-.037,2.53s.007,1.876.037,2.53a4.5,4.5,0,0,0,.285,1.49,3.138,3.138,0,0,0,1.795,1.795,4.5,4.5,0,0,0,1.49.285c.655.03.864.037,2.53.037s1.876-.007,2.53-.037a4.5,4.5,0,0,0,1.49-.285,3.138,3.138,0,0,0,1.795-1.795,4.505,4.505,0,0,0,.285-1.49c.03-.655.037-.864.037-2.53s-.007-1.876-.037-2.53a4.5,4.5,0,0,0-.285-1.49,3.138,3.138,0,0,0-1.795-1.795,4.5,4.5,0,0,0-1.49-.285C508.013,160.007,507.8,160,506.137,160Zm0,1.106c1.639,0,1.833.006,2.48.036a3.4,3.4,0,0,1,1.14.211,2.032,2.032,0,0,1,1.165,1.165,3.4,3.4,0,0,1,.211,1.14c.03.647.036.841.036,2.48s-.006,1.833-.036,2.48a3.4,3.4,0,0,1-.211,1.14,2.032,2.032,0,0,1-1.165,1.165,3.4,3.4,0,0,1-1.14.211c-.647.03-.841.036-2.48.036s-1.833-.006-2.48-.036a3.4,3.4,0,0,1-1.14-.211,2.032,2.032,0,0,1-1.165-1.165,3.4,3.4,0,0,1-.211-1.14c-.029-.647-.036-.841-.036-2.48s.006-1.833.036-2.48a3.4,3.4,0,0,1,.211-1.14,2.033,2.033,0,0,1,1.165-1.165,3.4,3.4,0,0,1,1.14-.211C504.3,161.112,504.5,161.106,506.137,161.106Zm0,1.88a3.151,3.151,0,1,0,3.151,3.151A3.151,3.151,0,0,0,506.137,162.986Zm0,5.2a2.046,2.046,0,1,1,2.046-2.046A2.046,2.046,0,0,1,506.137,168.183Zm4.012-5.322a.736.736,0,1,1-.736-.736A.736.736,0,0,1,510.149,162.861Z",
    transform: "translate(-500 -160)",
    fill: "#fff",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.7bbaf1d7dbcf5536d50fffb8b3993295.svg";
export { ForwardRef as ReactComponent };